module.exports = __webpack_public_path__ + "3f63c34b13b4a665a2c0df61268314fe.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-17.png
// module id = 2064
// module chunks = 0